import React from 'react';
import { withStyles, LinearProgress } from '@material-ui/core';
import { defaultStyles } from '../util/styles';
import { withRouter } from 'react-router-dom';
import { grey } from '@material-ui/core/colors';

const styles = theme => ({
  ...defaultStyles(theme),
  loading: {
    color: grey[500],
  },
  progress: {
    position: 'absolute',
    left: 0,
    right: 0,
    top: 0,
  },
});

function Loading(props) {
  const {classes} = props;
  return <LinearProgress className={classes.progress}/>;
}

export default withRouter(withStyles(styles)(Loading));